/** Auto-synced from cloudflare-worker detectByCity cityMap (non CABA/BA). */
import type { CityCatalogRow } from "./wishlistGeoCatalog";

export const AR_NATIONAL_CITY_CATALOG: CityCatalogRow[] = [
  { geo_code: "andalgala", name: "Andalgala", region: "Catamarca" },
  { geo_code: "belen", name: "Belen", region: "Catamarca" },
  { geo_code: "catamarca", name: "Catamarca", region: "Catamarca" },
  { geo_code: "recreo", name: "Recreo", region: "Catamarca" },
  { geo_code: "san fernando del valle de catamarca", name: "San Fernando Del Valle De Catamarca", region: "Catamarca" },
  { geo_code: "santa maria", name: "Santa Maria", region: "Catamarca" },
  { geo_code: "tinogasta", name: "Tinogasta", region: "Catamarca" },
  { geo_code: "valle viejo", name: "Valle Viejo", region: "Catamarca" },
  { geo_code: "barranqueras", name: "Barranqueras", region: "Chaco" },
  { geo_code: "chaco", name: "Chaco", region: "Chaco" },
  { geo_code: "charata", name: "Charata", region: "Chaco" },
  { geo_code: "presidencia roque saenz pena", name: "Presidencia Roque Saenz Pena", region: "Chaco" },
  { geo_code: "resistencia", name: "Resistencia", region: "Chaco" },
  { geo_code: "villa angela", name: "Villa Angela", region: "Chaco" },
  { geo_code: "chubut", name: "Chubut", region: "Chubut" },
  { geo_code: "comodoro rivadavia", name: "Comodoro Rivadavia", region: "Chubut" },
  { geo_code: "dolavon", name: "Dolavon", region: "Chubut" },
  { geo_code: "esquel", name: "Esquel", region: "Chubut" },
  { geo_code: "gaiman", name: "Gaiman", region: "Chubut" },
  { geo_code: "lago puelo", name: "Lago Puelo", region: "Chubut" },
  { geo_code: "puerto madryn", name: "Puerto Madryn", region: "Chubut" },
  { geo_code: "rada tilly", name: "Rada Tilly", region: "Chubut" },
  { geo_code: "sarmiento", name: "Sarmiento", region: "Chubut" },
  { geo_code: "trelew", name: "Trelew", region: "Chubut" },
  { geo_code: "alta gracia", name: "Alta Gracia", region: "Córdoba" },
  { geo_code: "bell ville", name: "Bell Ville", region: "Córdoba" },
  { geo_code: "cordoba", name: "Cordoba", region: "Córdoba" },
  { geo_code: "jesus maria", name: "Jesus Maria", region: "Córdoba" },
  { geo_code: "rio cuarto", name: "Rio Cuarto", region: "Córdoba" },
  { geo_code: "rio tercero", name: "Rio Tercero", region: "Córdoba" },
  { geo_code: "san francisco", name: "San Francisco", region: "Córdoba" },
  { geo_code: "villa carlos paz", name: "Villa Carlos Paz", region: "Córdoba" },
  { geo_code: "villa maria", name: "Villa Maria", region: "Córdoba" },
  { geo_code: "bella vista", name: "Bella Vista", region: "Corrientes" },
  { geo_code: "corrientes", name: "Corrientes", region: "Corrientes" },
  { geo_code: "curuzu cuatia", name: "Curuzu Cuatia", region: "Corrientes" },
  { geo_code: "esquina", name: "Esquina", region: "Corrientes" },
  { geo_code: "goya", name: "Goya", region: "Corrientes" },
  { geo_code: "monte caseros", name: "Monte Caseros", region: "Corrientes" },
  { geo_code: "paso de los libres", name: "Paso De Los Libres", region: "Corrientes" },
  { geo_code: "colon", name: "Colon", region: "Entre Ríos" },
  { geo_code: "concepcion del uruguay", name: "Concepcion Del Uruguay", region: "Entre Ríos" },
  { geo_code: "concordia", name: "Concordia", region: "Entre Ríos" },
  { geo_code: "entre rios", name: "Entre Rios", region: "Entre Ríos" },
  { geo_code: "federacion", name: "Federacion", region: "Entre Ríos" },
  { geo_code: "gualeguay", name: "Gualeguay", region: "Entre Ríos" },
  { geo_code: "gualeguaychu", name: "Gualeguaychu", region: "Entre Ríos" },
  { geo_code: "parana", name: "Parana", region: "Entre Ríos" },
  { geo_code: "victoria", name: "Victoria", region: "Entre Ríos" },
  { geo_code: "villaguay", name: "Villaguay", region: "Entre Ríos" },
  { geo_code: "clorinda", name: "Clorinda", region: "Formosa" },
  { geo_code: "comandante fontana", name: "Comandante Fontana", region: "Formosa" },
  { geo_code: "el colorado", name: "El Colorado", region: "Formosa" },
  { geo_code: "formosa", name: "Formosa", region: "Formosa" },
  { geo_code: "ingeniero juarez", name: "Ingeniero Juarez", region: "Formosa" },
  { geo_code: "las lomitas", name: "Las Lomitas", region: "Formosa" },
  { geo_code: "pirane", name: "Pirane", region: "Formosa" },
  { geo_code: "humahuaca", name: "Humahuaca", region: "Jujuy" },
  { geo_code: "jujuy", name: "Jujuy", region: "Jujuy" },
  { geo_code: "la quiaca", name: "La Quiaca", region: "Jujuy" },
  { geo_code: "libertador general san martin", name: "Libertador General San Martin", region: "Jujuy" },
  { geo_code: "palpala", name: "Palpala", region: "Jujuy" },
  { geo_code: "perico", name: "Perico", region: "Jujuy" },
  { geo_code: "san salvador de jujuy", name: "San Salvador De Jujuy", region: "Jujuy" },
  { geo_code: "tilcara", name: "Tilcara", region: "Jujuy" },
  { geo_code: "eduardo castex", name: "Eduardo Castex", region: "La Pampa" },
  { geo_code: "general acha", name: "General Acha", region: "La Pampa" },
  { geo_code: "general pico", name: "General Pico", region: "La Pampa" },
  { geo_code: "la pampa", name: "La Pampa", region: "La Pampa" },
  { geo_code: "macachin", name: "Macachin", region: "La Pampa" },
  { geo_code: "machacin", name: "Machacin", region: "La Pampa" },
  { geo_code: "realico", name: "Realico", region: "La Pampa" },
  { geo_code: "santa rosa", name: "Santa Rosa", region: "La Pampa" },
  { geo_code: "toay", name: "Toay", region: "La Pampa" },
  { geo_code: "victorica", name: "Victorica", region: "La Pampa" },
  { geo_code: "aimogasta", name: "Aimogasta", region: "La Rioja" },
  { geo_code: "arauco", name: "Arauco", region: "La Rioja" },
  { geo_code: "chamical", name: "Chamical", region: "La Rioja" },
  { geo_code: "chepes", name: "Chepes", region: "La Rioja" },
  { geo_code: "chilecito", name: "Chilecito", region: "La Rioja" },
  { geo_code: "famatina", name: "Famatina", region: "La Rioja" },
  { geo_code: "la rioja", name: "La Rioja", region: "La Rioja" },
  { geo_code: "villa union", name: "Villa Union", region: "La Rioja" },
  { geo_code: "godoy cruz", name: "Godoy Cruz", region: "Mendoza" },
  { geo_code: "guaymallen", name: "Guaymallen", region: "Mendoza" },
  { geo_code: "las heras", name: "Las Heras", region: "Mendoza" },
  { geo_code: "lujan de cuyo", name: "Lujan De Cuyo", region: "Mendoza" },
  { geo_code: "maipu", name: "Maipu", region: "Mendoza" },
  { geo_code: "malargue", name: "Malargue", region: "Mendoza" },
  { geo_code: "mendoza", name: "Mendoza", region: "Mendoza" },
  { geo_code: "san rafael", name: "San Rafael", region: "Mendoza" },
  { geo_code: "tunuyan", name: "Tunuyan", region: "Mendoza" },
  { geo_code: "apostoles", name: "Apostoles", region: "Misiones" },
  { geo_code: "eldorado", name: "Eldorado", region: "Misiones" },
  { geo_code: "jardin america", name: "Jardin America", region: "Misiones" },
  { geo_code: "leandro n. alem", name: "Leandro N. Alem", region: "Misiones" },
  { geo_code: "misiones", name: "Misiones", region: "Misiones" },
  { geo_code: "montecarlo", name: "Montecarlo", region: "Misiones" },
  { geo_code: "obera", name: "Obera", region: "Misiones" },
  { geo_code: "posadas", name: "Posadas", region: "Misiones" },
  { geo_code: "puerto iguazu", name: "Puerto Iguazu", region: "Misiones" },
  { geo_code: "centenario", name: "Centenario", region: "Neuquén" },
  { geo_code: "chos malal", name: "Chos Malal", region: "Neuquén" },
  { geo_code: "cutral co", name: "Cutral Co", region: "Neuquén" },
  { geo_code: "junin de los andes", name: "Junin De Los Andes", region: "Neuquén" },
  { geo_code: "neuquen", name: "Neuquen", region: "Neuquén" },
  { geo_code: "plottier", name: "Plottier", region: "Neuquén" },
  { geo_code: "san martin de los andes", name: "San Martin De Los Andes", region: "Neuquén" },
  { geo_code: "senillosa", name: "Senillosa", region: "Neuquén" },
  { geo_code: "villa la angostura", name: "Villa La Angostura", region: "Neuquén" },
  { geo_code: "zapala", name: "Zapala", region: "Neuquén" },
  { geo_code: "bariloche", name: "Bariloche", region: "Río Negro" },
  { geo_code: "catriel", name: "Catriel", region: "Río Negro" },
  { geo_code: "choele choel", name: "Choele Choel", region: "Río Negro" },
  { geo_code: "cinco saltos", name: "Cinco Saltos", region: "Río Negro" },
  { geo_code: "cipolletti", name: "Cipolletti", region: "Río Negro" },
  { geo_code: "el bolson", name: "El Bolson", region: "Río Negro" },
  { geo_code: "general roca", name: "General Roca", region: "Río Negro" },
  { geo_code: "ingeniero jacobacci", name: "Ingeniero Jacobacci", region: "Río Negro" },
  { geo_code: "rio negro", name: "Rio Negro", region: "Río Negro" },
  { geo_code: "san carlos de bariloche", name: "San Carlos De Bariloche", region: "Río Negro" },
  { geo_code: "viedma", name: "Viedma", region: "Río Negro" },
  { geo_code: "villa regina", name: "Villa Regina", region: "Río Negro" },
  { geo_code: "cafayate", name: "Cafayate", region: "Salta" },
  { geo_code: "general guemes", name: "General Guemes", region: "Salta" },
  { geo_code: "metan", name: "Metan", region: "Salta" },
  { geo_code: "oran", name: "Oran", region: "Salta" },
  { geo_code: "rosario de la frontera", name: "Rosario De La Frontera", region: "Salta" },
  { geo_code: "salta", name: "Salta", region: "Salta" },
  { geo_code: "tartagal", name: "Tartagal", region: "Salta" },
  { geo_code: "albardon", name: "Albardon", region: "San Juan" },
  { geo_code: "caucete", name: "Caucete", region: "San Juan" },
  { geo_code: "chimbas", name: "Chimbas", region: "San Juan" },
  { geo_code: "jachal", name: "Jachal", region: "San Juan" },
  { geo_code: "pocito", name: "Pocito", region: "San Juan" },
  { geo_code: "rivadavia", name: "Rivadavia", region: "San Juan" },
  { geo_code: "san juan", name: "San Juan", region: "San Juan" },
  { geo_code: "santa lucia", name: "Santa Lucia", region: "San Juan" },
  { geo_code: "valle fertil", name: "Valle Fertil", region: "San Juan" },
  { geo_code: "concaran", name: "Concaran", region: "San Luis" },
  { geo_code: "justo daract", name: "Justo Daract", region: "San Luis" },
  { geo_code: "la punta", name: "La Punta", region: "San Luis" },
  { geo_code: "san luis", name: "San Luis", region: "San Luis" },
  { geo_code: "tilisarao", name: "Tilisarao", region: "San Luis" },
  { geo_code: "villa mercedes", name: "Villa Mercedes", region: "San Luis" },
  { geo_code: "caleta olivia", name: "Caleta Olivia", region: "Santa Cruz" },
  { geo_code: "el calafate", name: "El Calafate", region: "Santa Cruz" },
  { geo_code: "el chalten", name: "El Chalten", region: "Santa Cruz" },
  { geo_code: "gobernador gregores", name: "Gobernador Gregores", region: "Santa Cruz" },
  { geo_code: "pico truncado", name: "Pico Truncado", region: "Santa Cruz" },
  { geo_code: "puerto deseado", name: "Puerto Deseado", region: "Santa Cruz" },
  { geo_code: "puerto san julian", name: "Puerto San Julian", region: "Santa Cruz" },
  { geo_code: "rio gallegos", name: "Rio Gallegos", region: "Santa Cruz" },
  { geo_code: "santa cruz", name: "Santa Cruz", region: "Santa Cruz" },
  { geo_code: "canada de gomez", name: "Canada De Gomez", region: "Santa Fe" },
  { geo_code: "galvez", name: "Galvez", region: "Santa Fe" },
  { geo_code: "rafaela", name: "Rafaela", region: "Santa Fe" },
  { geo_code: "reconquista", name: "Reconquista", region: "Santa Fe" },
  { geo_code: "rosario", name: "Rosario", region: "Santa Fe" },
  { geo_code: "santa fe", name: "Santa Fe", region: "Santa Fe" },
  { geo_code: "santo tome", name: "Santo Tome", region: "Santa Fe" },
  { geo_code: "venado tuerto", name: "Venado Tuerto", region: "Santa Fe" },
  { geo_code: "villa gobernador galvez", name: "Villa Gobernador Galvez", region: "Santa Fe" },
  { geo_code: "anatuya", name: "Anatuya", region: "Santiago del Estero" },
  { geo_code: "fernandez", name: "Fernandez", region: "Santiago del Estero" },
  { geo_code: "frias", name: "Frias", region: "Santiago del Estero" },
  { geo_code: "la banda", name: "La Banda", region: "Santiago del Estero" },
  { geo_code: "santiago del estero", name: "Santiago Del Estero", region: "Santiago del Estero" },
  { geo_code: "termas de rio hondo", name: "Termas De Rio Hondo", region: "Santiago del Estero" },
  { geo_code: "rio grande", name: "Rio Grande", region: "Tierra del Fuego" },
  { geo_code: "tierra del fuego", name: "Tierra Del Fuego", region: "Tierra del Fuego" },
  { geo_code: "tolhuin", name: "Tolhuin", region: "Tierra del Fuego" },
  { geo_code: "ushuaia", name: "Ushuaia", region: "Tierra del Fuego" },
  { geo_code: "banda del rio sali", name: "Banda Del Rio Sali", region: "Tucumán" },
  { geo_code: "san miguel de tucuman", name: "San Miguel De Tucuman", region: "Tucumán" },
  { geo_code: "tafi viejo", name: "Tafi Viejo", region: "Tucumán" },
  { geo_code: "tucuman", name: "Tucuman", region: "Tucumán" },
  { geo_code: "yerba buena", name: "Yerba Buena", region: "Tucumán" },
];
